/**
 * @step 1315: widget to show loading animation
 * @returns {JSX.Element}
 * @constructor
 */
const BioSpinner = () => {
    return (
        <div className="flex items-center justify-center">
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-primary" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0012 20c4.418 0 8-3.582 8-8h-4a4.001 4.001 0 01-3.874-3.874L8 8z"></path>
            </svg>
        </div>

    )
}

export default BioSpinner;